<template>
  <div id="app">
    <notifications group="notification_01" classes="vue-notification text-dark" :reverse="true"/>
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh!important;
  /* max-height: 100vh!important; */
  /* background-color: green; */
}
</style>
